import { css } from 'aphrodite';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { OpenNewWindowIcon } from '../../../web/components/svgs/icons/OpenNewWindowIcon';
import { hueStyleSheet, styleSheet } from './styles';

export type SettingsCardHue = keyof typeof hueStyleSheet;

interface IProps {
	description: string;
	href?: string;
	hue: SettingsCardHue;
	renderIcon: (className: string) => React.ReactNode;
	title: string;
	to?: string;
}

export const SettingsCardGrid: React.FC<React.PropsWithChildren> = ({ children }) => (
	<div className={css(styleSheet.grid)}>{children}</div>
);

export const SettingsCard: React.FC<IProps> = ({ description, href, hue, renderIcon, title, to }) => {
	const content = (
		<>
			<span className={css(styleSheet.iconTile, hueStyleSheet[hue])}>{renderIcon(css(styleSheet.icon))}</span>
			<span className={css(styleSheet.cardText)}>
				<span className={css(styleSheet.cardName)}>{title}</span>
				<span className={css(styleSheet.cardDescription)}>{description}</span>
			</span>
		</>
	);

	if (href) {
		return (
			<a className={css(styleSheet.card)} href={href} target='_blank' rel='noreferrer'>
				{content}
				<OpenNewWindowIcon className={css(styleSheet.externalIcon)} fill='currentColor' />
			</a>
		);
	}

	return (
		<Link className={css(styleSheet.card)} to={to}>
			{content}
		</Link>
	);
};
